import { customToast } from '@/components/toast/custom-react-toastify/v1';
import { useUserPageContextValueHook } from '@/contexts/UserPageContextProvider';

/**
 * 마이 페이지 상단: 내 페이지 주소 (공개 중) + 복사 / 열기
 */
export function FdLinkAlert(props) {
    const userPage = useUserPageContextValueHook()?.userPage;
    const url = `https://shool.uk/${userPage?.domainName || ''}`;

    const handleCopyLink = async () => {
        try {
            await navigator.clipboard.writeText(url);
            customToast.success('URL을 복사했습니다!');
        } catch (err) {
            console.log(err);
        }
    }

    return (
        <section className="flex flex-col gap-3 rounded-2xl bg-white p-4 ring-1 ring-black/[0.06] sm:flex-row sm:items-center sm:justify-between sm:p-5">
            <div className="min-w-0">
                <p className="flex items-center gap-1.5 text-xs font-semibold text-emerald-600">
                    <span className="relative flex h-2 w-2">
                        <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-emerald-400 opacity-60" />
                        <span className="relative inline-flex h-2 w-2 rounded-full bg-emerald-500" />
                    </span>
                    공개 중
                </p>
                <p className="mt-1 truncate text-[17px] font-bold text-gray-900">
                    shool.uk/<span className="text-[var(--mainColor)]">{userPage?.domainName}</span>
                </p>
            </div>
            <div className="flex shrink-0 gap-2">
                <button type="button" onClick={handleCopyLink} className="flex-1 rounded-xl bg-gray-900 px-4 py-2.5 text-sm font-semibold text-white transition hover:bg-gray-700 sm:flex-none">
                    URL 복사
                </button>
                <a href={url} target="_blank" rel="noreferrer" className="flex-1 rounded-xl bg-gray-100 px-4 py-2.5 text-center text-sm font-semibold text-gray-800 transition hover:bg-gray-200 sm:flex-none">
                    내 페이지 열기 ↗
                </a>
            </div>
        </section>
    );
}
